import type en from "../en/common";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  role_owner: "Propriétaire de la boutique",
  role_admin: "Administrateur de la boutique",
  role_product_manager: "Responsable produits",
  role_order_manager: "Responsable commandes",
  role_support: "Service client",
  role_analyst: "Analyste (lecture seule)",
  save: "Enregistrer",
  saving: "Enregistrement…",
  saveChanges: "Enregistrer les modifications",
  saved: "Enregistré",
  cancel: "Annuler",
  close: "Fermer",
  confirm: "Confirmer",
  delete: "Supprimer",
  deleting: "Suppression…",
  remove: "Retirer",
  edit: "Modifier",
  add: "Ajouter",
  create: "Créer",
  creating: "Création…",
  back: "Retour",
  next: "Suivant",
  previous: "Précédent",
  continue: "Continuer",
  search: "Rechercher",
  filter: "Filtrer",
  clear: "Effacer",
  apply: "Appliquer",
  view: "Voir",
  viewAll: "Tout voir",
  open: "Ouvrir",
  copy: "Copier",
  copied: "Copié",
  upload: "Téléverser",
  uploading: "Téléversement…",
  publish: "Publier",
  publishing: "Publication…",
  unpublish: "Dépublier",
  preview: "Aperçu",
  undo: "Annuler la modification",
  retry: "Réessayer",
  yes: "Oui",
  no: "Non",
  none: "Aucun",
  optional: "facultatif",
  required: "Obligatoire",
  loading: "Chargement…",
  actions: "Actions",
  status: "Statut",
  name: "Nom",
  email: "E-mail",
  phone: "Téléphone",
  date: "Date",
  total: "Total",
  amount: "Montant",
  price: "Prix",
  quantity: "Quantité",
  title: "Titre",
  description: "Description",
  type: "Type",
  createdAt: "Créé",
  updatedAt: "Mis à jour",
  enabled: "Activé",
  disabled: "Désactivé",
  active: "Actif",
  inactive: "Inactif",
  draft: "Brouillon",
  published: "Publié",
  archived: "Archivé",
  live: "En ligne",
  pending: "En attente",
  all: "Tous",
  page: "Page {page} sur {pages}",
  showing: "{from}–{to} sur {total}",
  noResults: "Aucun résultat",
  somethingWrong: "Une erreur s’est produite. Veuillez réessayer.",
  notAllowed: "Votre rôle dans cette boutique ne permet pas cette action.",
  learnMore: "En savoir plus",
  unsavedChanges: "Vous avez des modifications non enregistrées.",
  areYouSure: "Êtes-vous sûr ?",
  cannotUndo: "Cette action est irréversible.",
  testMode: "Mode test",
  language: "Langue",
};

export default fr;
